module.exports = __webpack_public_path__ + "assets/img/printer.a6461d78.svg";